import ui from './actions.js';
import { getIsEnvTest } from '~/state/ducks/app/selectors.js';


export const asyncDataLoading = (name, operation, hasSelector, ownProps) => async (dispatch, getState) => {

    const isEnvTest = getIsEnvTest(getState());

    dispatch(ui.dataLoading.on(name));

    try {
        const data = await operation(ownProps);

        if (!hasSelector && Boolean(data)) {
            dispatch(ui.dataLoading.data.set(name, data));
        }

        dispatch(ui.dataLoading.off(name));

    } catch (error) {
        if (!isEnvTest) {
            console.error(error); // eslint-disable-line no-console
        }
        dispatch(ui.dataLoading.fail(name));
    }
};
